import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme: Theme) => ({
    item: {
        '&:hover': {
            backgroundColor: theme.palette.menuListHover.light,
        },
    },
}));

interface Props {
    anchorEl: HTMLElement | null;
    menuId: string;
    onCloseHandler: () => void;
    onDeleteHandler: () => void;
    onToggleHandler: () => void;
    fieldIsPrimary: boolean;
}

export default function MenuEmailFieldActionsRaw({
    anchorEl,
    menuId,
    onCloseHandler,
    onDeleteHandler,
    onToggleHandler,
    fieldIsPrimary,
}: Props) {
    const { classes } = useStyles();

    return (
        <Menu
            id={menuId}
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClick={onCloseHandler}
            onClose={onCloseHandler}
        >
            <MenuItem className={classes.item} onClick={onToggleHandler}>
                Edit field
            </MenuItem>
            <MenuItem className={classes.item} onClick={onDeleteHandler}>
                Delete field
            </MenuItem>
        </Menu>
    );
}
